import module from 'empresa/module.js'
import template from './template.html'

export class EmpresaConfiguracionRegistrosPatronalesMigrarAgrupacionesItemComponent {
  item
  onChange

  seleccionar () {
    this.item.seleccionado = !this.item.seleccionado
    this.onChange()
  }
}

module.component('empresaConfiguracionRegistrosPatronalesMigrarAgrupacionesItem', {
  controller: EmpresaConfiguracionRegistrosPatronalesMigrarAgrupacionesItemComponent,
  template,
  bindings: {
    item: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/configuracion/registrosPatronales/migrar/agrupacion/item/component.js